import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import CreateTaskCommentRequest from '../../../projects/task-comments/i-service/models/CreateTaskCommentRequest';
import UpdateCommentRequest from '../../../projects/task-comments/i-service/models/request/UpdateCommentRequest';
import GetCommentListRequest from '../../../projects/task-comments/i-service/models/request/GetCommentListRequest';
import GetCommentListByIdRequest from '../../../projects/task-comments/i-service/models/request/GetCommentListByIdRequest';
import RemoveTaskCommentRequest from '../../../projects/task-comments/i-service/models/RemoveTaskCommentRequest';
import RemoveFilesCommentRequest from '../../../projects/task-comments/i-service/models/request/RemoveFilesCommentRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import TaskCommentResponse from '../../../projects/task-comments/i-service/models/TaskCommentResponse';
import UpdateCommentResponse from '../../../projects/task-comments/i-service/models/response/UpdateCommentResponse';
import GetCommentListResponse from '../../../projects/task-comments/i-service/models/response/GetCommentListResponse';
import GetCommentListByIdResponse from '../../../projects/task-comments/i-service/models/response/GetCommentListByIdResponse';
import GetCommentListItem from '../../../projects/task-comments/i-service/models/response/GetCommentListItem';
import OnRemoveCommentResponse from '../../../projects/task-comments/i-service/models/response/OnRemoveCommentResponse';
import OnUpdateCommentResponse from '../../../projects/task-comments/i-service/models/response/OnUpdateCommentResponse';

/**
 * * Сервис для работы с комментариями
 */
export default class TaskCommentService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	/**
	 * * Событие на создание комментария
	 */
	OnCreateCommentEvent = new Events<WsResponseModelT<GetCommentListItem>>();
	/**
	 * * Событие на удаление комментария
	 */
	OnRemoveCommentEvent = new Events<WsResponseModelT<OnRemoveCommentResponse>>();
	/**
	 * * Событие на обновление комментария
	 */
	OnUpdateCommentEvent = new Events<WsResponseModelT<OnUpdateCommentResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('TaskCommentService', 'OnCreateComment', 'Main', (res: WsResponseModelT<GetCommentListItem>) => {
			self.OnCreateCommentEvent.trigger(res);
		});
		webApiService.on('TaskCommentService', 'OnRemoveComment', 'Main', (res: WsResponseModelT<OnRemoveCommentResponse>) => {
			self.OnRemoveCommentEvent.trigger(res);
		});
		webApiService.on('TaskCommentService', 'OnUpdateComment', 'Main', (res: WsResponseModelT<OnUpdateCommentResponse>) => {
			self.OnUpdateCommentEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Создание комментария
	 */
	async CreateComment(request: CreateTaskCommentRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskCommentService',
			Method: 'CreateComment',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление комментария
	 */
	async UpdateComment(request: UpdateCommentRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskCommentService',
			Method: 'UpdateComment',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение комментариев
	 */
	async GetCommentList(request: GetCommentListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskCommentService',
			Method: 'GetCommentList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение комментариев от id до id
	 */
	async GetCommentListById(request: GetCommentListByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskCommentService',
			Method: 'GetCommentListById',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление комментариев
	 */
	async RemoveComment(model: RemoveTaskCommentRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskCommentService',
			Method: 'RemoveComment',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	async RemoveFiles(request: RemoveFilesCommentRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskCommentService',
			Method: 'RemoveFiles',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Создание комментария
	 */
	async createCommentAsync(request: CreateTaskCommentRequest): Promise<TaskCommentResponse> {
		return new Promise<TaskCommentResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskCommentService',
				Method: 'CreateComment',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<TaskCommentResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskCommentResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление комментария
	 */
	async updateCommentAsync(request: UpdateCommentRequest): Promise<UpdateCommentResponse> {
		return new Promise<UpdateCommentResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskCommentService',
				Method: 'UpdateComment',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UpdateCommentResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UpdateCommentResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение комментариев
	 */
	async getCommentListAsync(request: GetCommentListRequest): Promise<GetCommentListResponse> {
		return new Promise<GetCommentListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskCommentService',
				Method: 'GetCommentList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetCommentListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetCommentListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение комментариев от id до id
	 */
	async getCommentListByIdAsync(request: GetCommentListByIdRequest): Promise<GetCommentListByIdResponse> {
		return new Promise<GetCommentListByIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskCommentService',
				Method: 'GetCommentListById',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetCommentListByIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetCommentListByIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление комментариев
	 */
	async removeCommentAsync(model: RemoveTaskCommentRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskCommentService',
				Method: 'RemoveComment',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async removeFilesAsync(request: RemoveFilesCommentRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskCommentService',
				Method: 'RemoveFiles',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}